import externalLinkIcon from "@assets/images/external-link.svg";
import TrashCan from "@assets/images/trash.svg";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import { showNotifyMessage } from "@saleor/changeOrder/utils";
import {
  DataApplyAllProps,
  typeApplyAll
} from "@saleor/changeOrderDomestic/components/ItemDetailsTabEdit/types";
import { formatConditionGroup } from "@saleor/changeOrderExport/utils";
import Checkbox from "@saleor/components/Checkbox";
import DatePicker from "@saleor/components/DatePicker";
import DatePickerApplyAll from "@saleor/components/DatePickerApplyAll/DatePickerApplyAll";
import DecimalFormat from "@saleor/components/DecimalFormat";
import DialogConfirmDelete from "@saleor/components/DialogConfirmDelete";
import MyTypography from "@saleor/components/MyTypography";
import NumberFormat from "@saleor/components/NumberFormat/NumberFormat";
import PopoverApplyAll from "@saleor/components/PopoverApplyAll";
import SearchRoute from "@saleor/components/SearchRoute";
import { SingleSelectField } from "@saleor/components/SingleSelectField";
import { SingleTextField } from "@saleor/components/SingleTextField";
import SingleTextFieldNoBlock from "@saleor/components/SingleTextField2";
import Skeleton from "@saleor/components/Skeleton";
import StickyHorizontalScrollBar from "@saleor/components/StickyHorizontalScrollBar";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { TablePaginationCustom } from "@saleor/components/TablePaginationCustom";
import TextAreaField from "@saleor/components/TextAreaField";
import { REGEX_ONLY_NUMBER, REGEX_ONLY_NUMBER_CHARACTER } from "@saleor/config";
import FullScreenButton from "@saleor/createOrderExport/components/FullScreenButton";
import { MAX_LENGTH_REF_PI } from "@saleor/createOrderExport/components/MaterialItemTab/const";
import { ExportOrderSortField } from "@saleor/createOrderExport/urls";
import EmptyProduct from "@saleor/createOrderExport/views/CartDetailExport/EmptyProduct";
import { createPackingList } from "@saleor/createOrderExport/views/CreateOrderView/utils";
import { useDeleteExportOrderLineDraftMutation } from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useNotifier from "@saleor/hooks/useNotifier";
import { renderCollection } from "@saleor/misc";
import { getPlainTextFromEnum } from "@saleor/utils/message";
import {
  calculateNewPackage,
  calculateNewPalletNo,
  calculateTheWeight
} from "@saleor/utils/number";
import { getArrowDirection } from "@saleor/utils/sort";
import classNames from "classnames";
import moment from "moment-timezone";
import React, { useEffect, useMemo, useRef, useState } from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

import { MaterialItemTabEditProps } from "../MaterialItemTab/Edit";
import ModalInputParameter from "../ModalInputParameter";
import { getFormik } from "./formik";
import useStyles from "./styles";

const totalCols = 20;

const AddNewItem: React.FC<MaterialItemTabEditProps> = ({
  data,
  settings,
  onUpdateListSettings,
  onNextPage,
  onPreviousPage,
  pageInfo,
  disabled,
  onSort,
  sort,
  onNextLastPage,
  latestPageItemNumber,
  onPreviousFirstPage,
  totalCount,
  handleSubmitOrder,
  submitOrderCall,
  listMaterial,
  setListMaterial,
  listMaterialAll,
  currency
}) => {
  const notify = useNotifier();
  const intl = useIntl();
  const classes = useStyles();
  const [appState, dispatchAppState] = useAppState();
  const { fullScreen } = appState;
  const [tab, setTab] = useState<number>(0);
  const formik = getFormik(listMaterial);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [reRender, setReRender] = useState<boolean>(false);
  const [dataApplyAll, setDataApplyAll] = useState<DataApplyAllProps>({
    anchorEl: null,
    title: "",
    placeholder: "",
    type: null
  });
  const [componentKey, setComponentKey] = useState<number>(0);
  const [openApplyAll, setOpenApplyAll] = useState<boolean>(false);
  const [isOpenModalInputParameter, setIsOpenModalInputParameter] = useState<
    boolean
  >(false);
  const [orderLine, setOrderLine] = useState(null);
  const [itemNoDelete, setItemNoDelete] = useState<string>("");

  const containerRef = useRef<HTMLDivElement | null>(null);

  const [
    deleteLineDraft,
    { loading: loadingDeleteLineDraft }
  ] = useDeleteExportOrderLineDraftMutation();
  const handleConfirmDelete = () => {
    if (itemNoDelete && !loadingDeleteLineDraft) {
      deleteLineDraft({
        variables: {
          id: listMaterial.find(item => item.itemNo === itemNoDelete).id
        }
      }).then(response => {
        if (response?.data?.deleteExportOrderLineDraft?.success) {
          setListMaterial(prev =>
            prev.filter(line => line.itemNo !== itemNoDelete)
          );
        } else {
          showNotifyMessage(
            notify,
            response?.data?.deleteExportOrderLineDraft?.errors,
            [],
            [],
            []
          );
        }
      });
    }

    setOpenDelete(false);
  };

  const isOrderStatusPartialDelivery = useMemo(
    () => data?.orderItems[0]?.deliveryStatus === "Partial Delivery",
    [data]
  );

  const handleOpenModalInputParameter = orderId => {
    setComponentKey(prev => prev + 1);
    setIsOpenModalInputParameter(true);
    setOrderLine(orderId);
  };

  const handleCloseModalInputParameter = () => {
    setIsOpenModalInputParameter(false);
  };

  const isItemDisabled = item =>
    item.statusCancel === "Cancel" ||
    item.statusCancel === "Delete" ||
    !item.isAddNew;

  useEffect(() => {
    setDelivery(
      listMaterialAll
        .filter(item => item.untimatedTol && item.isAddNew)
        .map(line => line.itemNo)
    );
  }, [data]);

  useEffect(() => {
    dispatchAppState({
      payload: {
        tabMaterial: tab
      },
      type: "setTabMaterial"
    });
  }, [tab]);

  useEffect(() => {
    setReRender(prevState => !prevState);
  }, [fullScreen]);

  useEffect(() => {
    setReRender(prevState => !prevState);
    if (containerRef.current) {
      containerRef!.current!.scrollLeft = 0;
    }
  }, [tab]);

  const {
    isSelected: isErrorQuantity,
    listElements: listElementsError,
    add: addError,
    remove: removeError
  } = useBulkActions([]);

  const {
    isSelected: isSelectedDelivery,
    listElements: listDeliveryDelivery,
    reset: resetDelivery,
    toggle: toggleDelivery,
    set: setDelivery
  } = useBulkActions([]);

  const handleDeleteItem = (itemNo: string) => {
    setItemNoDelete(itemNo);
    setOpenDelete(true);
  };

  const renderTabTable = () => (
    <div className={classes.tabBox}>
      <div
        className={classNames(
          classes.boxShadowTab,
          tab === 0 ? classes.z1 : classes.z0
        )}
      >
        <Button
          id="sales-condition-tab"
          data-testid="sales-condition-tab"
          onClick={() => setTab(0)}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              setTab(0);
            }
          }}
          className={classNames(
            classes.tableTab,
            tab === 0 ? classes.active : classes.notActive
          )}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage: "Sales Condition"
            })}
          </MyTypography>
        </Button>
      </div>
      <div
        className={classNames(
          classes.boxShadowTab,
          tab === 1 ? classes.z1 : classes.z0
        )}
      >
        <Button
          id="order-details-tab"
          data-testid="order-details-tab"
          onClick={() => setTab(1)}
          onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              setTab(1);
            }
          }}
          className={classNames(
            classes.tableTab,
            classes.tabB,
            tab === 1 ? classes.active : classes.notActive
          )}
        >
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage: "Order Details"
            })}
          </MyTypography>
        </Button>
      </div>
    </div>
  );

  const renderTabA = () => (
    <>
      <TableCellHeader
        width={120}
        style={{ minWidth: "120px", borderRight: 0 }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "จำนวน" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={72} style={{ minWidth: "72px" }}>
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={80}
        textAlign={"right"}
        style={{ minWidth: "80px" }}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "น้ำหนัก" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"center"}
      >
        <MyTypography variant={"body3"}>
          {intl.formatMessage({ defaultMessage: "หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={128} style={{ minWidth: "128px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Cat (EO)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"right"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "ราคา/หน่วย" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={88} style={{ minWidth: "88px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Currency" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Plant" })}
        </MyTypography>
        <Button
          data-testid="apply-all-plant-button"
          className={classes.btnApplyAll}
          onClick={setApplyPlant}
          variant={"contained"}
          color={"secondary"}
        >
          <MyTypography variant={"caption"}>Apply all</MyTypography>
        </Button>
      </TableCellHeader>
      <TableCellHeader width={165} style={{ minWidth: "165px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ref. PI Stock" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={190}
        style={{ minWidth: "190px" }}
        className={classes.borderRight}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Original Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={210}
        style={{ minWidth: "210px" }}
        className={classes.borderRight}
        textAlign={"center"}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Request Date" })}
        </MyTypography>
        <DatePickerApplyAll onApplyAll={handleApplyAllRequestDate} />
      </TableCellHeader>
      <TableCellHeader
        width={190}
        style={{ minWidth: "190px" }}
        className={classes.borderRight}
      >
        <MyTypography variant={"subtitle3"} className={classes.confirmDate}>
          {intl.formatMessage({ defaultMessage: "Confirm Date" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader>
        {intl.formatMessage({ defaultMessage: "(P)" })}
      </TableCellHeader>
      <TableCellHeader width={190} style={{ minWidth: "190px" }}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Item Status" })}
        </MyTypography>
      </TableCellHeader>
    </>
  );

  const renderTabB = () => (
    <>
      <TableCellHeader width={470} style={{ minWidth: "470px" }} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Route" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={"160px"}
        style={{ minWidth: "160px" }}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Condition Group 1" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader width={160} style={{ minWidth: "160px" }} rowSpan={2}>
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Material Group 2" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        textAlign={"center"}
        style={{ minWidth: "112px" }}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align="center">
          {intl.formatMessage({ defaultMessage: "Commission (%)" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"} align="center">
          {intl.formatMessage({ defaultMessage: "Commission amount" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Com. Unit" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={280}
        style={{ minWidth: "280px" }}
        textAlign={"center"}
        className={classes.customCell}
        colSpan={3}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Delivery Tolerance" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Roll Diameter" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Roll Core Diameter" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "No. of Rolls" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Ream/Roll per Pallet" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Pallet Size" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Pallet No." })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={112}
        style={{ minWidth: "112px" }}
        align={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "No. of Package" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Packing List" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Shipping Point" })}
        </MyTypography>
      </TableCellHeader>
      <TableCellHeader
        width={440}
        style={{ minWidth: "440px" }}
        textAlign={"center"}
        rowSpan={2}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Remark" })}
        </MyTypography>
      </TableCellHeader>
      {/* <TableCellHeader
        width={128}
        style={{ minWidth: "128px" }}
        align={"center"}
        rowSpan={2}
        className={classes.borderRight}
      >
        <MyTypography variant={"subtitle3"}>
          {intl.formatMessage({ defaultMessage: "Reason for Reject" })}
        </MyTypography>
      </TableCellHeader> */}
    </>
  );

  const handleClickCheckBox = (e, id: string) => {
    toggleDelivery(id);
    const check = isSelectedDelivery(id);
    handleChangeInput(e, id, e.target.name, !check);
  };

  const handleChangeRoute = (route, itemId) => {
    const indexOfItem = listMaterial.findIndex(item => item.itemNo === itemId);

    const value = {
      target: {
        value: route,
        name: `route[${indexOfItem}]`
      }
    };
    handleChangeInput(value, itemId, "route");
  };
  const getAllQuantityByMatCode = (matCode, itemNoExclude) => {
    const listSameMatCode = listMaterialAll
      .filter(item => item.isAddNew)
      .filter(
        item => item.material === matCode && item.itemNo !== itemNoExclude
      );
    return listSameMatCode.reduce(
      (totalQuantity, item) => (totalQuantity += +item.quantity),
      0
    );
  };

  const handleChangeInput = (
    event: any,
    id: string,
    field: string,
    valueExtra?
  ) => {
    const value = event.target.value;
    formik.setFieldValue(event.target.name, event.target.value, true);

    const newState = listMaterialAll.map(item => {
      if (item.itemNo === id) {
        if (field === "quantity") {
          const value = parseInt(event.target.value, 10);
          const totalQuantitySameMatCode = getAllQuantityByMatCode(
            item.material,
            item.itemNo
          );
          const totalQuantity = totalQuantitySameMatCode + value;
          const limitQuantity = +item.itemRemain || 0;

          const checkQuantity = totalQuantity > limitQuantity;

          if (checkQuantity) {
            addError(item.itemNo);
          } else {
            removeError(item.itemNo);
          }
          const reamRollPerPallet = item.reamRollPerPallet || 0;
          item.noOfPackage = calculateNewPackage(
            value,
            reamRollPerPallet
          ).toString();
        }
        if (field === "rollPerPallet") {
          const value = parseInt(event.target.value, 10) || 0;
          item.noOfPackage = calculateNewPackage(
            item.itemQty,
            value
          ).toString();
        }
        if (field === "requestDate") {
          const isNewDateAfter = moment(value).isAfter(moment());
          item.errorDate = !isNewDateAfter;
          if (item.isAddNew) {
            item.isRequestDateChanged = true;
          }
        }
        return {
          ...item,
          [field]: valueExtra || event.target.value,
          isChange: true
        };
      }
      return item;
    });
    if (field === "quantity" || field === "rollPerPallet") {
      const newList = [...newState];
      newList.forEach((item, index) => {
        item.palletNo = calculateNewPalletNo(newList, index);
        item.packingList = createPackingList(item);
      });
      setListMaterial(newList);
    } else {
      setListMaterial(newState);
    }
  };

  const handleCheckboxAllDelivery = () => {
    if (
      listDeliveryDelivery.length ===
        listMaterialAll.filter(e => e.isAddNew).length ||
      listMaterialAll.filter(e => e.isK01K09)
    ) {
      resetDelivery();
      updateCheckboxAll(false);
      return;
    }
    setDelivery(
      listMaterialAll.filter(e => e.isAddNew).map(item => item.itemNo)
    );
    updateCheckboxAll(true);
  };

  const updateCheckboxAll = value => {
    const newState = listMaterialAll.map(item => {
      if (item.isAddNew) {
        return {
          ...item,
          deliveryTolUnlimited: value,
          isChange: true
        };
      }
      return item;
    });
    setListMaterial(newState);
  };
  const setApplyPlant = e => {
    if (!isOrderStatusPartialDelivery) {
      setDataApplyAll({
        type: typeApplyAll.applyPlant,
        title: "Plant",
        placeholder: "ระบุ Plant",
        anchorEl: e.currentTarget,
        maxLength: 4,
        regex: REGEX_ONLY_NUMBER_CHARACTER
      });
      setComponentKey(prev => prev + 1);
      setOpenApplyAll(true);
    }
  };

  const handleApplyAll = value => {
    const tempLine = [...listMaterialAll];
    if (dataApplyAll.type === typeApplyAll.applyPlant) {
      tempLine.forEach(item => {
        if (item.isAddNew) {
          item.plant = value;
        }
      });
    }
    setListMaterial(tempLine);
    setOpenApplyAll(false);
  };

  const handleApplyAllRequestDate = value => {
    const tempLine = JSON.parse(JSON.stringify(listMaterialAll));
    tempLine.forEach(item => {
      if (item.isAddNew) {
        item.requestDate = moment(value).format("YYYY-MM-DD");
        item.errorDate = null;
      }
    });
    setListMaterial(tempLine);
  };

  const handleSaveInputParameter = choice => {
    setListMaterial(prev =>
      prev.map(item => {
        if (item.itemNo === orderLine.itemNo) {
          return {
            ...item,
            inquiryMethod: choice
          };
        }
        return item;
      })
    );
    setIsOpenModalInputParameter(false);
  };

  const checkErrorByField = (field: string, index) =>
    !!(formik.errors[field] && formik.errors[field][index]);

  const getErrorTextQuantity = (field: string, index, id) =>
    (formik.errors[field] && formik.errors[field][index]) ||
    (isErrorQuantity(id) &&
      intl.formatMessage({
        defaultMessage: "จำนวนที่สั่งมีมากกว่าจำนวนคงเหลือ"
      })) ||
    "";

  useEffect(() => {
    if (submitOrderCall) {
      const listErrorDate = listMaterialAll.filter(
        item => !moment(item.requestDate).isAfter(moment()) && item.isAddNew
      );
      if (listErrorDate.length) {
        const newListMaterial = listMaterialAll.map(item => {
          if (!item.isAddNew) {
            return item;
          }
          const errorDate = !moment(item.requestDate).isAfter(moment());
          return {
            ...item,
            isRequestDateChanged: true,
            errorDate
          };
        });
        setListMaterial(newListMaterial);
      }
      if (!listElementsError.length && !listErrorDate.length) {
        handleSubmitOrder();
      } else {
        handleSubmitOrder(true);
      }
    }
  }, [submitOrderCall, formik.isValid]);

  const textErrorDate = intl.formatMessage({
    defaultMessage:
      "กรุณาเปลี่ยน “Request Date” (ไม่สามารถใส่วันที่ปัจจุบันหรือวันที่ ผ่านมาแล้วได้)"
  });

  const isContainer = item => item?.itemCategory === "ZKC0";

  const isK01K09 = item =>
    item.materialGroup1?.includes("K01") ||
    item.materialGroup1?.includes("K09");

  const isSpecialPlant = item => item.isMaterialOutsource;

  return (
    <>
      {listMaterial?.length ? (
        <>
          <div className={classes.topBox}>
            <div className={classes.deleteBox} />
            <FullScreenButton />
          </div>
          <div
            className={classes.tableRoot}
            style={{ overflowX: "auto" }}
            ref={containerRef}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.freezeCell4}>
                    {renderTabTable()}
                  </TableCell>
                </TableRow>
                <TableRow data-testid="table-header">
                  <TableCellHeader
                    rowSpan={2}
                    className={classes.freezeCell1}
                    style={{ width: "90px", minWidth: "90px" }}
                    textAlign={"center"}
                    direction={
                      sort.sort === ExportOrderSortField.item_no
                        ? getArrowDirection(!sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    onClick={() => onSort(ExportOrderSortField.item_no)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Item No." })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell2}
                    style={{ width: "170px", minWidth: "170px" }}
                    rowSpan={2}
                    direction={
                      sort.sort === ExportOrderSortField.material_code
                        ? getArrowDirection(sort.asc)
                        : undefined
                    }
                    arrowPosition="right"
                    onClick={() => onSort(ExportOrderSortField.material_code)}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({ defaultMessage: "Mat. Code" })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    className={classes.freezeCell3}
                    style={{
                      width: "320px",
                      minWidth: "320px",
                      borderRight: "transparent"
                    }}
                    rowSpan={2}
                  >
                    <MyTypography variant={"subtitle3"}>
                      {intl.formatMessage({
                        defaultMessage: "Mat. Description"
                      })}
                    </MyTypography>
                  </TableCellHeader>
                  <TableCellHeader
                    rowSpan={2}
                    className={classes.cellFrezze4Add}
                  />
                  {tab === 0 ? renderTabA() : renderTabB()}
                </TableRow>
                {tab === 1 && (
                  <TableRow>
                    <TableCellHeader
                      width={93}
                      style={{ minWidth: "93px" }}
                      className={classNames(
                        classes.customCell,
                        classes.noBorderRight,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>Under (%)</span>
                    </TableCellHeader>
                    <TableCellHeader
                      width={93}
                      style={{ minWidth: "93px" }}
                      className={classNames(
                        classes.customCell,
                        classes.noBorderRight,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>Over (%)</span>
                    </TableCellHeader>
                    <TableCellHeader
                      width={100}
                      style={{ minWidth: "100" }}
                      className={classNames(
                        classes.borderRight,
                        classes.customCell,
                        classes.unlimited,
                        classes.thDelivery
                      )}
                    >
                      <span className={classes.delivery}>
                        <Checkbox
                          data-testid="checkbox-all-delivery"
                          className={classes.checkBox}
                          size={"small"}
                          checked={
                            listDeliveryDelivery.length ===
                            listMaterialAll.length
                          }
                          indeterminate={
                            listDeliveryDelivery.length > 0 &&
                            listDeliveryDelivery.length < listMaterialAll.length
                          }
                          onClick={() => handleCheckboxAllDelivery()}
                        />
                        Unlimited
                      </span>
                    </TableCellHeader>
                  </TableRow>
                )}
              </TableHead>
              <TableBody>
                {listMaterial && listMaterial.length > 0 ? (
                  renderCollection(listMaterial, (line, index) => (
                    <TableRow
                      key={line.itemNo}
                      className={classNames({
                        [classes.disabledLine]: isItemDisabled(line)
                      })}
                    >
                      <TableCell
                        className={classes.freezeCell1}
                        data-testid="itemNo-cell"
                      >
                        <MyTypography variant={"body3"}>
                          {line.itemNo}
                        </MyTypography>
                      </TableCell>
                      <TableCell
                        className={classes.freezeCell2}
                        data-testid="material-cell"
                      >
                        <MyTypography variant={"body3"}>
                          {line.material}
                        </MyTypography>
                      </TableCell>
                      <TableCell
                        className={classes.freezeCell3}
                        style={{
                          borderRight: "transparent"
                        }}
                        data-testid="materialDesc-cell"
                      >
                        <MyTypography variant={"body3"}>
                          {line.materialDesc}
                        </MyTypography>
                      </TableCell>
                      <TableCell
                        className={classes.cellFrezze4Add}
                        align={"center"}
                        data-testid="delete-item-cell"
                      >
                        {line.isAddNew ? (
                          <SVG
                            src={TrashCan}
                            cursor="pointer"
                            data-testid="delete-item-button"
                            onClick={() => handleDeleteItem(line.itemNo)}
                          />
                        ) : (
                          ""
                        )}
                      </TableCell>

                      {tab === 0 ? (
                        <>
                          <TableCell
                            colSpan={2}
                            style={{ minWidth: "284px" }}
                            width={284}
                            data-testid="quantity-cell"
                          >
                            <div className={classes.boxQuantity}>
                              <MyTypography
                                variant={"body3"}
                                style={{
                                  minWidth: 112
                                }}
                              >
                                {isItemDisabled(line) ? (
                                  line.quantity
                                ) : (
                                  <NumberFormat
                                    inputDisabled={isOrderStatusPartialDelivery}
                                    customClass={classes.numberInput}
                                    name={`quantity[${index}]`}
                                    testId="quantity-input"
                                    onChange={e =>
                                      handleChangeInput(
                                        e,
                                        line.itemNo,
                                        "quantity"
                                      )
                                    }
                                    allowLeadingZeros
                                    decimalScale={0}
                                    placeholder={"ระบุจำนวน"}
                                    value={line.quantity}
                                    error={
                                      checkErrorByField("quantity", index) ||
                                      isErrorQuantity(line.itemNo)
                                    }
                                  />
                                )}
                              </MyTypography>
                              <MyTypography
                                variant={"body3"}
                                className={classes.salesUnit}
                              >
                                {isContainer(line) ? "EA" : "ROL"}
                              </MyTypography>
                            </div>
                            <span className={classes.txtError}>
                              {getErrorTextQuantity(
                                "quantity",
                                index,
                                line.itemNo
                              )}
                            </span>
                          </TableCell>
                          <TableCell align={"center"} data-testid="weight-cell">
                            <MyTypography variant={"body3"}>
                              {isContainer(line) ? (
                                "-"
                              ) : (
                                <DecimalFormat
                                  value={Number(
                                    calculateTheWeight(
                                      line.weightUnit,
                                      Number(line.saleQtyFactor),
                                      Number(line.quantity)
                                    )?.toString()
                                  )}
                                  isGrayDecimal={false}
                                  countDecimal={3}
                                />
                              )}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="weightUnit-cell">
                            {isItemDisabled(line) ? (
                              isContainer(line) ? (
                                ""
                              ) : (
                                line.weightUnit ?? "TON"
                              )
                            ) : (
                              <SingleSelectField
                                InputProps={{
                                  classes: { input: classes.txtInputSelect },
                                  inputProps: {
                                    "data-testid": "weightUnit-input"
                                  }
                                }}
                                className={classes.selectField}
                                choices={[
                                  {
                                    label: (
                                      <MyTypography variant={"subtitle3"}>
                                        TON
                                      </MyTypography>
                                    ),
                                    value: "TON"
                                  },
                                  {
                                    label: (
                                      <MyTypography variant={"subtitle3"}>
                                        Kg.
                                      </MyTypography>
                                    ),
                                    value: "Kg."
                                  }
                                ]}
                                onChange={e =>
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "weightUnit"
                                  )
                                }
                                placeholder={isContainer(line) ? "" : "Select"}
                                value={
                                  isContainer(line)
                                    ? ""
                                    : line.weightUnit ?? "TON"
                                }
                                name={`weightUnit[${index}]`}
                                error={checkErrorByField("weightUnit", index)}
                                disabled={isContainer(line)}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="itemCategory-cell">
                            {isItemDisabled(line) ? (
                              line.itemCategory
                            ) : (
                              <SingleSelectField
                                InputProps={{
                                  classes: { input: classes.txtInputSelect },
                                  inputProps: {
                                    "data-testid": "itemCategory-input"
                                  }
                                }}
                                className={classes.selectField}
                                choices={
                                  isContainer(line)
                                    ? [
                                        {
                                          label: (
                                            <MyTypography variant={"subtitle3"}>
                                              ZKC0
                                            </MyTypography>
                                          ),
                                          value: "ZKC0"
                                        }
                                      ]
                                    : [
                                        {
                                          label: (
                                            <MyTypography
                                              variant={"subtitle3"}
                                            ></MyTypography>
                                          ),
                                          value: ""
                                        },
                                        {
                                          label: (
                                            <MyTypography variant={"subtitle3"}>
                                              ZTNN
                                            </MyTypography>
                                          ),
                                          value: "ZTNN"
                                        },
                                        {
                                          label: (
                                            <MyTypography variant={"subtitle3"}>
                                              ZTN1
                                            </MyTypography>
                                          ),
                                          value: "ZTN1"
                                        }
                                      ]
                                }
                                onChange={e =>
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "itemCategory"
                                  )
                                }
                                placeholder={"Select"}
                                value={line.itemCategory}
                                name={`itemCatEo[${index}]`}
                                error={checkErrorByField("itemCatEo", index)}
                                allowBlank
                              />
                            )}
                          </TableCell>
                          <TableCell
                            align={"right"}
                            data-testid="conditionRate-cell"
                          >
                            {isContainer(line) ? (
                              ""
                            ) : (
                              <DecimalFormat
                                value={Number(line?.conditionRate)}
                                isGrayDecimal={false}
                                countDecimal={2}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="currency-cell">
                            <MyTypography variant={"body3"}>
                              {isContainer(line) ? "" : currency}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="plant-cell">
                            {isItemDisabled(line) ? (
                              formik.values.plant[index]
                            ) : (
                              <SingleTextField
                                disabled={
                                  isOrderStatusPartialDelivery ||
                                  isContainer(line)
                                }
                                placeholder="ระบุ Plant"
                                regex={REGEX_ONLY_NUMBER_CHARACTER}
                                value={isContainer(line) ? "" : line.plant}
                                name={`plant[${index}]`}
                                InputProps={{
                                  inputProps: { "data-testid": "plant-input" }
                                }}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  handleChangeInput(e, line.itemNo, "plant")
                                }
                                maxLengthProps={4}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="refPiStock-cell">
                            {isItemDisabled(line) ? (
                              line.refPiStock
                            ) : (
                              <SingleTextField
                                maxLengthProps={MAX_LENGTH_REF_PI}
                                value={line.refPiStock}
                                name={`refPiStock[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "refPiStock-input"
                                  }
                                }}
                                placeholder="ระบุ Ref. PI Stock"
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "refPiStock"
                                  )
                                }
                                disabled={isContainer(line)}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="originalRequestDate-cell">
                            <MyTypography variant={"body3"}>
                              {line?.originalRequestDate || "-"}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="requestDate-cell">
                            <DatePicker
                              disabled={
                                isOrderStatusPartialDelivery ||
                                isItemDisabled(line)
                              }
                              placeholderColor="black"
                              value={line.requestDate}
                              data-testid="requestDate-input"
                              placeholder="--/--/----"
                              name={`requestDate[${index}]`}
                              disabledInitialRendering
                              onChange={e =>
                                handleChangeInput(e, line.itemNo, "requestDate")
                              }
                              error={
                                line.isAddNew &&
                                line.errorDate &&
                                line.isRequestDateChanged
                              }
                              helperText={
                                line.isAddNew &&
                                line.errorDate &&
                                line.isRequestDateChanged
                                  ? textErrorDate
                                  : ""
                              }
                              noBlock
                            />
                          </TableCell>
                          <TableCell data-testid="confirmDate-cell">
                            <MyTypography variant={"body3"}>
                              {line?.confirmDate
                                ? moment(line.confirmDate).format("DD/MM/YYYY")
                                : "-"}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="parameter-cell">
                            <Button
                              className={classes.button}
                              disabled={isItemDisabled(line)}
                              variant="contained"
                              onClick={() => {
                                handleOpenModalInputParameter(line);
                              }}
                              color="secondary"
                            >
                              <SVG src={externalLinkIcon} />
                            </Button>
                          </TableCell>
                          <TableCell data-testid="itemStatusEn-cell">
                            <MyTypography variant={"body3"}>
                              {line?.isAddNew
                                ? ""
                                : getPlainTextFromEnum(line?.itemStatusEn)}
                            </MyTypography>
                          </TableCell>
                        </>
                      ) : (
                        <>
                          <TableCell data-testid="route-cell">
                            {isItemDisabled(line) ? (
                              formik.values.route[index]
                            ) : (
                              <SearchRoute
                                route={formik.values.route[index]}
                                setRoute={handleChangeRoute}
                                contractNo={data?.contractNo}
                                itemId={line.itemNo}
                                buttonWithNonContained
                                placehoder="ระบุ Route"
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="conditionGroup-cell">
                            <MyTypography variant={"body3"}>
                              {formatConditionGroup(line)}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="materialGroup1-cell">
                            <MyTypography variant={"body3"}>
                              {line?.materialGroup1}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="commission-cell">
                            <MyTypography variant={"body3"}>
                              {line?.commission}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="commissionAmount-cell">
                            <MyTypography variant={"body3"}>
                              {line?.commissionAmount ? (
                                <DecimalFormat
                                  value={Number(line?.commissionAmount)}
                                  isGrayDecimal={false}
                                  countDecimal={3}
                                />
                              ) : (
                                ""
                              )}
                            </MyTypography>
                          </TableCell>
                          <TableCell data-testid="commissionUnit-cell">
                            <MyTypography variant={"body3"}>
                              {line?.commissionAmount
                                ? line?.commissionUnit
                                : ""}
                            </MyTypography>
                          </TableCell>
                          <TableCell
                            className={classes.noBorderRight}
                            data-testid="deliveryTolUnder-cell"
                          >
                            <MyTypography variant={"body3"}>
                              {isItemDisabled(line) ? (
                                formik.values.deliveryTolUnder[index] || 0
                              ) : (
                                <SingleTextFieldNoBlock
                                  name={`deliveryTolUnder[${index}]`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "deliveryTolUnder-input"
                                    }
                                  }}
                                  placeholder="Under"
                                  value={
                                    isK01K09(line) || line.deliveryTolUnlimited
                                      ? "0"
                                      : formik.values.deliveryTolUnder[index]
                                  }
                                  error={checkErrorByField(
                                    "deliveryTolUnder",
                                    index
                                  )}
                                  onChange={e => {
                                    if (!line.deliveryTolUnlimited) {
                                      handleChangeInput(
                                        e,
                                        line.itemNo,
                                        "deliveryTolUnder"
                                      );
                                    }
                                  }}
                                  disabled={
                                    isK01K09(line) ||
                                    isSelectedDelivery(line.itemNo) ||
                                    isItemDisabled(line)
                                  }
                                  className={classNames(
                                    classes.textFieldCustom,
                                    {
                                      [classes.disabled]: isSelectedDelivery(
                                        line.itemNo
                                      )
                                    }
                                  )}
                                  regex={REGEX_ONLY_NUMBER}
                                  numberLimit={100}
                                />
                              )}
                            </MyTypography>
                          </TableCell>
                          <TableCell
                            className={classes.noBorderRight}
                            data-testid="deliveryTolOver-cell"
                          >
                            <MyTypography variant={"body3"}>
                              {isItemDisabled(line) ? (
                                formik.values.deliveryTolOver[index] || 0
                              ) : (
                                <SingleTextFieldNoBlock
                                  name={`deliveryTolOver[${index}]`}
                                  InputProps={{
                                    inputProps: {
                                      "data-testid": "deliveryTolOver-input"
                                    }
                                  }}
                                  value={
                                    isK01K09(line) || line.deliveryTolUnlimited
                                      ? "0"
                                      : formik.values.deliveryTolOver[index]
                                  }
                                  placeholder="Over"
                                  error={checkErrorByField(
                                    "deliveryTolOver",
                                    index
                                  )}
                                  onChange={e => {
                                    if (!line.deliveryTolUnlimited) {
                                      handleChangeInput(
                                        e,
                                        line.itemNo,
                                        "deliveryTolOver"
                                      );
                                    }
                                  }}
                                  className={classNames(
                                    classes.textFieldCustom,
                                    {
                                      [classes.disabled]: isSelectedDelivery(
                                        line.itemNo
                                      )
                                    }
                                  )}
                                  disabled={
                                    isK01K09(line) ||
                                    isSelectedDelivery(line.itemNo) ||
                                    isItemDisabled(line)
                                  }
                                  regex={REGEX_ONLY_NUMBER}
                                  numberLimit={100}
                                />
                              )}
                            </MyTypography>
                          </TableCell>
                          <TableCell
                            className={classes.unlimited}
                            data-testid="deliveryTolUnlimited-cell"
                          >
                            <span className={classes.delivery}>
                              <Checkbox
                                size={"small"}
                                disabled={
                                  isK01K09(line) || isItemDisabled(line)
                                }
                                data-testid="deliveryTolUnlimited-checkbox"
                                name={`deliveryTolUnlimited`}
                                checked={
                                  isItemDisabled(line)
                                    ? false
                                    : isSelectedDelivery(line.itemNo)
                                }
                                onClick={e =>
                                  handleClickCheckBox(e, line.itemNo)
                                }
                              />
                              Unlimited
                            </span>
                          </TableCell>
                          <TableCell data-testid="rollDiameter-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) ||
                              isContainer(line) ||
                              isSpecialPlant(line) ? (
                                ""
                              ) : (
                                formik.values.rollDiameter[index]
                              )
                            ) : (
                              <SingleTextField
                                name={`rollDiameter[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "rollDiameter-input"
                                  }
                                }}
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : formik.values.rollDiameter[index]
                                }
                                disabled={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                }
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "rollDiameter"
                                  )
                                }
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField("rollDiameter", index)
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="rollCoreDiameter-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) || isContainer(line) ? (
                                ""
                              ) : (
                                formik.values.rollCoreDiameter[index]
                              )
                            ) : (
                              <SingleTextField
                                name={`rollCoreDiameter[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "rollCoreDiameter-input"
                                  }
                                }}
                                value={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isSpecialPlant(line)
                                    ? ""
                                    : formik.values.rollCoreDiameter[index]
                                }
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                disabled={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                }
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "rollCoreDiameter"
                                  )
                                }
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField(
                                        "rollCoreDiameter",
                                        index
                                      )
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="rollQuantity-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) ||
                              isContainer(line) ||
                              isSpecialPlant(line) ? (
                                ""
                              ) : (
                                formik.values.rollQuantity[index]
                              )
                            ) : (
                              <SingleTextField
                                name={`rollQuantity[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "rollQuantity-input"
                                  }
                                }}
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : formik.values.rollQuantity[index]
                                }
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                disabled={isK01K09(line) || isContainer(line)}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "rollQuantity"
                                  )
                                }
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField("rollQuantity", index)
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="rollPerPallet-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) ||
                              isContainer(line) ||
                              isSpecialPlant(line) ? (
                                ""
                              ) : (
                                line?.reamRollPerPallet
                              )
                            ) : (
                              <SingleTextField
                                name={`rollPerPallet[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "rollPerPallet-input"
                                  }
                                }}
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line?.reamRollPerPallet
                                }
                                disabled={isK01K09(line) || isContainer(line)}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "rollPerPallet"
                                  )
                                }
                                regex={REGEX_ONLY_NUMBER}
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField("rollPerPallet", index)
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="palletSize-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) ||
                              isContainer(line) ||
                              isSpecialPlant(line) ? (
                                ""
                              ) : (
                                formik.values.palletSize[index]
                              )
                            ) : (
                              <SingleTextField
                                name={`palletSize[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "palletSize-input"
                                  }
                                }}
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : formik.values.palletSize[index]
                                }
                                disabled={isK01K09(line) || isContainer(line)}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "palletSize"
                                  )
                                }
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField("palletSize", index)
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="palletNo-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) || isContainer(line) ? (
                                ""
                              ) : (
                                line.palletNo
                              )
                            ) : (
                              <SingleTextField
                                name={`palletNo[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "palletNo-input"
                                  }
                                }}
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line.palletNo
                                }
                                disabled={isK01K09(line) || isContainer(line)}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(e, line.itemNo, "palletNo")
                                }
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField("palletNo", index)
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="packageQuantity-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) ||
                              isContainer(line) ||
                              isSpecialPlant(line) ? (
                                ""
                              ) : (
                                line.palletNo
                              )
                            ) : (
                              <SingleTextField
                                name={`packageQuantity[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "packageQuantity-input"
                                  }
                                }}
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุ"
                                }
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line?.noOfPackage
                                }
                                disabled={isK01K09(line) || isContainer(line)}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "packageQuantity"
                                  )
                                }
                                regex={REGEX_ONLY_NUMBER}
                                error={
                                  isK01K09(line) || isContainer(line)
                                    ? false
                                    : checkErrorByField(
                                        "packageQuantity",
                                        index
                                      )
                                }
                                maxLengthProps={10}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="packingList-cell">
                            {isItemDisabled(line) ? (
                              isK01K09(line) ||
                              isContainer(line) ||
                              isSpecialPlant(line) ? (
                                ""
                              ) : (
                                line.palletNo
                              )
                            ) : (
                              <SingleTextField
                                placeholder={
                                  isK01K09(line) ||
                                  isContainer(line) ||
                                  isItemDisabled(line)
                                    ? ""
                                    : "ระบุข้อความ"
                                }
                                // placeholder="ระบุข้อความ"
                                name={`packingList[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "packingList-input"
                                  }
                                }}
                                value={
                                  isK01K09(line) || isContainer(line)
                                    ? ""
                                    : line.packingList
                                }
                                disabled={isK01K09(line) || isContainer(line)}
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  !(isK01K09(line) || isContainer(line)) &&
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "packingList"
                                  )
                                }
                                maxLengthProps={132}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="shippingPoint-cell">
                            {isItemDisabled(line) ? (
                              formik.values.shippingPoint[index]
                            ) : (
                              <SingleTextField
                                name={`shippingPoint[${index}]`}
                                InputProps={{
                                  inputProps: {
                                    "data-testid": "shippingPoint-input"
                                  }
                                }}
                                value={formik.values.shippingPoint[index]}
                                className={classes.textFieldCustom}
                                placeholder={"ระบุข้อความ"}
                                onChange={e =>
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "shippingPoint"
                                  )
                                }
                                error={checkErrorByField(
                                  "shippingPoint",
                                  index
                                )}
                                regex={REGEX_ONLY_NUMBER}
                                maxLengthProps={4}
                              />
                            )}
                          </TableCell>
                          <TableCell data-testid="remark-cell">
                            {isItemDisabled(line) ? (
                              line?.remark
                            ) : (
                              <TextAreaField
                                value={line?.remark}
                                name={`remark[${index}]`}
                                data-testid="remark-input"
                                placeHolder="ระบุข้อความ"
                                className={classes.textFieldCustom}
                                onChange={e =>
                                  handleChangeInput(e, line.itemNo, "remark")
                                }
                                verticalResizingOnly
                                rowsMin={1}
                                maxLength={1320}
                                lineLimit={132}
                                rowsMax={10}
                              />
                            )}
                          </TableCell>
                          {/* <TableCell>
                            {isItemDisabled(line) ? (
                              line?.rejectReason
                            ) : (
                              <SingleSelectField
                                InputProps={{
                                  classes: { input: classes.txtInputSelect }
                                }}
                                className={classes.selectField}
                                choices={[
                                  {
                                    label: (
                                      <MyTypography variant={"subtitle3"}>
                                        No
                                      </MyTypography>
                                    ),
                                    value: ScgExportRejectReason.NO
                                  },
                                  {
                                    label: (
                                      <MyTypography variant={"subtitle3"}>
                                        Yes
                                      </MyTypography>
                                    ),
                                    value: ScgExportRejectReason.YES
                                  }
                                ]}
                                onChange={e =>
                                  handleChangeInput(
                                    e,
                                    line.itemNo,
                                    "rejectReason"
                                  )
                                }
                                placeholder={"Select"}
                                value={line?.rejectReason}
                                name={`rejectReason[${index}]`}
                              />
                            )}
                          </TableCell> */}
                        </>
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={totalCols}>
                      <Skeleton />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
            {listMaterial && listMaterial.length > 0 ? (
              <StickyHorizontalScrollBar
                container={containerRef}
                reRender={reRender}
                bottom={fullScreen ? 0 : 165}
              />
            ) : null}
          </div>
          <TablePaginationCustom
            hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
            hasPreviousPage={
              pageInfo && !disabled ? pageInfo.hasPreviousPage : false
            }
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
            totalCount={totalCount}
            selectColor="#007E92"
            settings={settings}
            onUpdateListSettings={onUpdateListSettings}
            isBackFistPage
            isNextLastPage
            latestPageItemNumber={latestPageItemNumber}
            onNextLastPage={onNextLastPage}
            onPreviousFirstPage={onPreviousFirstPage}
            disabled={disabled}
          />
        </>
      ) : null}
      {!listMaterial?.length ? <EmptyProduct hideTotal /> : null}

      <DialogConfirmDelete
        onConfirm={handleConfirmDelete}
        onCancel={() => setOpenDelete(false)}
        open={openDelete}
        title={
          <span className={classes.titleDelete}>
            Delete item สินค้าที่เลือก
          </span>
        }
        cancelText={"กลับไป"}
        okText={"ยืนยัน"}
        content={
          <MyTypography variant={"body2"}>
            {intl.formatMessage({
              defaultMessage:
                'กรุณากด "ยืนยัน" เพื่อลบรายการสินค้าที่เลือก หรือกด กลับไป" เพื่อปิดหน้าต่างนี้'
            })}
          </MyTypography>
        }
      />
      <ModalInputParameter
        key={`ip_${componentKey}`}
        open={isOpenModalInputParameter}
        initialValue={orderLine?.inquiryMethod}
        onClose={handleCloseModalInputParameter}
        onSave={handleSaveInputParameter}
        allowChangeInquiryMethod={true}
      />
      <PopoverApplyAll
        key={`apply_${componentKey}`}
        title={dataApplyAll.title}
        onOk={handleApplyAll}
        open={openApplyAll}
        onClose={() => setOpenApplyAll(false)}
        anchorEl={dataApplyAll.anchorEl}
        placeholder={dataApplyAll.placeholder}
        maxLengthInput={dataApplyAll.maxLength}
        regexInput={dataApplyAll.regex}
      />
    </>
  );
};

export default AddNewItem;
